export default __webpack_public_path__ + "static/media/fondo-00.c51ca4f6.jpg";